module.exports = __webpack_public_path__ + "assets/img/no_photo.a92af394.jpeg";